import {
  ShieldX,
  SearchX,
  ArrowLeft,
  Home,
} from "lucide-react";

import { useNavigate } from "react-router-dom";

const ErrorPage = ({
  type = "404",
}) => {
  const navigate = useNavigate();

  const isUnauthorized =
    type === "403";

  return (
    <div
      className="
      relative flex min-h-screen
      items-center justify-center
      overflow-hidden
      bg-white
      px-4 py-10
    "
    >
      {/* BG BLUR */}

      <div
        className="
        absolute -top-32 -left-20
        h-80 w-80 rounded-full
        bg-[#FFF1F5]
        blur-3xl
      "
      />

      <div
        className="
        absolute -bottom-32 -right-20
        h-80 w-80 rounded-full
        bg-[#F8F4F1]
        blur-3xl
      "
      />

      {/* CARD */}

      <div
        className="
        relative z-10 w-full
        max-w-2xl overflow-hidden
        rounded-[38px]
        border border-[#EFE4DE]
        bg-white/95
        p-6 shadow-2xl
        backdrop-blur
        sm:p-10
      "
      >
        {/* TOP ICON */}

        <div
          className="
          mx-auto flex h-24 w-24
          items-center justify-center
          rounded-full
          bg-gradient-to-br
          from-[#FFF1F5]
          to-[#F8F4F1]
          sm:h-28 sm:w-28
        "
        >
          {isUnauthorized ? (
            <ShieldX
              size={52}
              className="text-red-600"
            />
          ) : (
            <SearchX
              size={52}
              className="text-[#c90243]"
            />
          )}
        </div>

        {/* CODE */}

        <h1
          className="
          mt-7 text-center
          text-6xl font-black
          tracking-tight text-[#2B2B2B]
          sm:text-7xl
        "
        >
          {isUnauthorized
            ? "403"
            : "404"}
        </h1>

        {/* TITLE */}

        <h2
          className="
          mt-3 text-center
          text-2xl font-black
          text-[#c90243]
          sm:text-4xl
        "
        >
          {isUnauthorized
            ? "Unauthorized Access"
            : "Page Not Found"}
        </h2>

        {/* DESC */}

        <p
          className="
          mx-auto mt-4 max-w-xl
          text-center text-sm
          leading-7 text-[#777]
          sm:text-lg
        "
        >
          {isUnauthorized
            ? "You don’t have permission to access this page. Please contact administrator if you believe this is a mistake."
            : "The page you are trying to access doesn’t exist or may have been moved."}
        </p>

        {/* ACTIONS */}

        <div
          className="
          mt-10 grid gap-3
          sm:grid-cols-2
        "
        >
          {/* BACK */}

          <button
            onClick={() => {
              if (
                window.history.length > 1
              ) {
                navigate(-1);
              } else {
                navigate("/");
              }
            }}
            className="
            flex h-[56px]
            items-center justify-center
            gap-2 rounded-2xl
            border border-[#EFE4DE]
            bg-[#FAF7F5]
            text-sm font-bold
            text-[#2B2B2B]
            transition hover:bg-[#F3ECE8]
            sm:text-base
          "
          >
            <ArrowLeft size={18} />
            Previous Page
          </button>

          {/* HOME */}

          <button
            onClick={() =>
              navigate("/")
            }
            className="
            flex h-[56px]
            items-center justify-center
            gap-2 rounded-2xl
            bg-[#c90243]
            text-sm font-bold
            text-white
            shadow-lg
            shadow-[#c90243]/20
            transition hover:opacity-90
            sm:text-base
          "
          >
            <Home size={18} />
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;